import EstadoDeudaUpdate from './EstadoDeudaUpdate'
export {EstadoDeudaUpdate}
export default EstadoDeudaUpdate
